var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstall1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0273 29.6093C30.6368 29.2187 30.0036 29.2187 29.6131 29.6092C29.2226 29.9998 29.2226 30.6329 29.6131 31.0235L31.0273 29.6093ZM35.9622 37.3726C36.3527 37.7631 36.9858 37.7631 37.3764 37.3726C37.7669 36.9821 37.7669 36.3489 37.3764 35.9584L35.9622 37.3726ZM29.6131 31.0235L35.9622 37.3726L37.3764 35.9584L31.0273 29.6093L29.6131 31.0235ZM17.6217 30.9035C10.2842 30.9035 4.33594 24.9553 4.33594 17.6178H2.33594C2.33594 26.0599 9.1796 32.9035 17.6217 32.9035V30.9035ZM30.9074 17.6178C30.9074 24.9553 24.9592 30.9035 17.6217 30.9035V32.9035C26.0638 32.9035 32.9074 26.0599 32.9074 17.6178H30.9074ZM17.6217 4.33203C24.9592 4.33203 30.9074 10.2803 30.9074 17.6178H32.9074C32.9074 9.17569 26.0638 2.33203 17.6217 2.33203V4.33203ZM17.6217 2.33203C9.1796 2.33203 2.33594 9.17569 2.33594 17.6178H4.33594C4.33594 10.2803 10.2842 4.33203 17.6217 4.33203V2.33203Z",
    fill: "#EDB755"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstall1);
export default __webpack_public_path__ + "static/media/install_1.ad04c553a36664a9f537b9bc3be41061.svg";
export { ForwardRef as ReactComponent };